/* Smile.io launcher theme-fit for LA Sports Cards (white-on-black store).
   Smile renders its launcher black-on-black here; both launcher frames are
   same-origin, so we inject an override stylesheet into them. Runs from
   layout/theme.liquid. Safe if Smile is absent (no-ops). */
(function () {
  /* Outline ring only — never repaint backgrounds. Smile reuses its white-
     painted container across transition/skeleton states, so forcing a white
     background made previously-invisible interim surfaces flash as white
     blobs. The black pill + white ring stays correct in every state and
     matches the store's outlined-chip look. */
  var RING = 'inset 0 0 0 2px #fff,0 2px 14px rgba(255,255,255,.28)';
  /* Smile's collapsed launcher doc is wider than its frame (content 81px in a
     60px viewport) and leaves html overflow:visible — Windows classic
     scrollbars render as gray "scroll wheels" on white tracks inside the
     bubble. Clip the frame doc and suppress its scrollbars in every state. */
  var CLIP =
    'html,body{overflow:hidden!important;background:transparent!important}' +
    '::-webkit-scrollbar{display:none!important;width:0!important;height:0!important}';
  var CSS_FULL = CLIP + '.launcher-container{box-shadow:' + RING + '!important}';
  var CSS_LITE = CLIP + 'button{box-shadow:' + RING + '!important}';

  function inject(frame, css) {
    try {
      var d = frame.contentDocument;
      if (!d || !d.head) return;
      var st = d.getElementById('lasc-smile-fit');
      if (!st) {
        st = d.createElement('style');
        st.id = 'lasc-smile-fit';
        d.head.appendChild(st);
      }
      if (st.textContent !== css) st.textContent = css;
    } catch (e) {
      /* frame not ready or cross-origin: ignore */
    }
  }

  function sweep() {
    document.querySelectorAll('iframe.smile-launcher-frame').forEach(function (f) {
      inject(f, CSS_FULL);
    });
    var lite = document.getElementById('smile-lite-launcher-frame');
    if (lite) inject(lite, CSS_LITE);
  }

  new MutationObserver(sweep).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  sweep();
  /* srcless frames occasionally re-render their document after insertion;
     re-assert for the first minute, then the observer alone suffices */
  var n = 0;
  var iv = setInterval(function () {
    sweep();
    if (++n >= 30) clearInterval(iv);
  }, 2000);
})();
